export default "__VITE_ASSET__3d6bc9c8__"